import { takeLatest, put, select, all } from 'redux-saga/effects';
import { autoRequest } from '@api/createRequestStore';
import { get } from '@api/sharing';
import { DASHBOARD_TYPE } from '@utils/constants';
import selector, { sharingResponseSelector } from './selectors';
import { APPLY_REQUEST } from '../request/types';
import { APPLY_TIMELINE_CONFIG } from '../config/types';
import { APPLY_TIMELINE_UI } from '../ui/types';
import * as actions from './actions';
import * as types from './types';
import { addNewSharedTab } from '../../sharedTabs/action';
import { updateRequest } from '../utils';

function* afterRequest() {
  const state = yield select(sharingResponseSelector);
  if (!state) {
    return;
  }

  const {
    request,
    configStore,
    uiStore,
    common: { selectedCustomerId },
  } = state;

  // update request time interval
  updateRequest(request);

  const { payload: id } = yield select(selector);
  try {
    yield all([
      put({
        type: APPLY_REQUEST,
        request,
      }),
      put({
        type: APPLY_TIMELINE_CONFIG,
        config: configStore,
      }),
      put({
        type: APPLY_TIMELINE_UI,
        ui: uiStore,
      }),
      put(addNewSharedTab({ type: DASHBOARD_TYPE.TIMELINE, id, state }, selectedCustomerId)),
    ]);
  } catch (error) {
    console.error(error);
    throw error;
  }
}

function* initRequest() {
  yield put(actions.initRequest());
}

function* fetching({ id }) {
  yield actions.fetching();

  try {
    yield autoRequest(get, types.SCOPE, id, afterRequest);
  } catch (error) {
    throw error.message;
  }
}

function* watchInitRequest() {
  yield takeLatest([types.INIT], initRequest);
}

function* watchFetching() {
  yield takeLatest([types.GET_SHARING], fetching);
}

export default [watchInitRequest, watchFetching];
